
import { computed, defineComponent, reactive } from 'vue'

// @components
import NewModal from '@/common/new-components/NewModal/index.vue'
import FileReader from '@/common/components/UI/FileReader/index.vue'
import NewInput from '@/ui-kit/NewInput/index.vue'

// @validations
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

// @composable
import { useFormData } from '@/common/composable/useFormData'

export default defineComponent({
    components: {
        NewModal,
        FileReader,
        NewInput,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        clientId: {
            type: Number,
            required: true,
        },
        type: {
            type: Number,
            required: true,
        },
    },
    emits: ['submit', 'cancel'],
    setup(props, { emit }) {
        const { getFormData } = useFormData()

        const state = reactive({
            is_loading: false,
        })

        const payload = reactive({
            cost: null as number | null,
            checks: [] as File[],
        })

        const validation$ = useVuelidate(
            {
                cost: { required },
                checks: { required },
            },
            payload
        )

        const onSubmit = () => {
            if (props.loading) return

            validation$.value.$touch()
            if (validation$.value.$invalid) return

            const form_data = { clientId: props.clientId, type: props.type, ...payload }

            emit('submit', getFormData(form_data))
        }

        const onCancel = () => {
            if (props.loading) return
            emit('cancel')
        }

        //

        const title = computed(() => (props.type === 2 ? 'Платная парковка' : 'Платный проезд'))

        //

        return {
            state,
            payload,
            //
            validation$,
            //
            onSubmit,
            onCancel,
            //
            title,
        }
    },
})
